export default "__VITE_ASSET__cdLLziPS__"